// extracted by mini-css-extract-plugin
module.exports = {"grid":"axis_grid__1YKtK","zero":"axis_zero__Hggk9","label":"axis_label__XQt0k","line":"axis_line__8QTAz","tick":"axis_tick__iIK3n"};